import UserForm from '@/components/user/UserForm';
import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const CoachManagementEditPage: React.FC = () => {
  const [t] = useTranslation('');
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className='title flex'>
          <span className='pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer' onClick={() => navigate(PATH.coach_management)}></span>
          <span className='ml-3'>
            {t('user.edit_coach')}
          </span>
        </h2>
      </div>
      <UserForm id={Number(id)} />
    </>
  )
}

export default CoachManagementEditPage;